var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"custom-evaluate"},[_c('div',{staticClass:"evaluate-wrap"},_vm._l((_vm.evaluateData),function(item){return _c('evaluateItem',{key:item.key,attrs:{"evaluateData":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }